import httpClient from "@/core/axios";

export default {
    namespaced: true,
    state: {
        article: null,
        breadcrumbs: []
    },
    getters: {
        article(state) {
            return state.article;
        },
        breadcrumbs(state) {
            return state.breadcrumbs;
        }
    },
    actions: {
        async fetchArticle(context, { slug }) {
            await context.commit("FLUSH_ARTICLE");
            return httpClient
                .get(`/api/guest/app/:app_uuid/knowledge/articles/${slug}`)
                .then(data => context.commit("SET_ARTICLE", data));
        }
    },
    mutations: {
        SET_ARTICLE(state, data) {
            state.article = data.article;

            state.breadcrumbs = [
                { name: "Knowledge", label: data.taxonomy.name }
            ];
            state.breadcrumbs.push(
                ...data.breadcrumbs.map(taxon => {
                    return {
                        label: taxon.name,
                        name: "KnowledgeTaxon",
                        params: { slug: taxon.slug }
                    };
                })
            );
            state.breadcrumbs.push({ label: data.article.title });
        },
        FLUSH_ARTICLE(state) {
            state.article = null;
        }
    }
};
